import actionTypes from '../constants/action-types';

const setSiteIdToSwitchTemplate = (siteId) => ({
  type: actionTypes.SET_SITE_ID_TO_SWITCH_TEMPLATE,
  payload: { siteId },
});

export default setSiteIdToSwitchTemplate;
